/** Import promises polyfill for older browsers (needed for fetch polyfill)
 * from https://github.com/taylorhakes/promise-polyfill
 */
import 'promise-polyfill/src/polyfill'
/** Import official Github fetch API polyfill for older browsers 
 * from https://github.com/github/fetch
 */
import 'whatwg-fetch'
/**
 * VARS
 */
const ofTheGods = './hermes' // change back to './hermes' for production
// Saves the original label texts for each input along with the id
const labelsOriginalTexts = new Array
// get the page language from the <html> element set a flag either to "_en" or empty ""
const pageLang = document.documentElement.lang
const langFlag = (pageLang !== "en") ? "" : "_en"
// Error messages for form labels
const errMsg_specialChars = (langFlag !== "_en") ? 'Unzulässige Sonderzeichen' : 'Invalid special characters'
const errMsg_email = (langFlag !== "_en") ? 'Keine gültige E-Mail-Adresse' : 'Not a valid email address'
const errMsg_emptyReq = (langFlag !== "_en") ? 'Feld muss ausgefüllt sein' : 'This field must be completed'
const errMsg_dsgvoCheck = (langFlag !== "_en") ? '\u2190 Bitte bestätigen Sie: ' : '\u2190 Please confirm: ' // with left arrow
// Javascript Timeout for form sending
const noTimeToSend = 5000
const loadTime = Date.now()
/** 
 * SET ACTIVE STATE
 * 
 * Material design style form label animation: change field state when label is active or inactive
 */

const setActive = (el, active) => {
    const formField = el.parentNode.parentNode
    if (active) {
        formField.classList.add('form-field--is-active')
        // if the field is tagged as required and empty and the error message is active - remove it
        setRequiredError(el, false)
    } else {
        formField.classList.remove('form-field--is-active')
        el.value === '' ?
            formField.classList.remove('form-field--is-filled') :
            formField.classList.add('form-field--is-filled')
    }
}
/**
 * SET ERROR CLASS FOR REQUIRED AND EMPTY
 * @param {the input elment} el 
 * @param {error boolean: true = field is required and empty / false = field is not empty (or active)} error 
 */
const setRequiredError = (el, error) => {
    const formField = el.parentNode.parentNode
    if (error) {
        formField.classList.add('form-field--is-required-error')
    } else {
        formField.classList.remove('form-field--is-required-error')
    }
}
/**
 * FORM FIELD INPUT STATES
 */

const inputs = document.querySelectorAll(".form-field__input")
inputs.forEach((el) => {
    el.onblur = () => {
        setActive(el, false)
        // perform check if the fields content is valid
        checkField(el, false)
    }
    el.onfocus = () => {
        setActive(el, true)
        // lets set the label directly to "valid" everytime the field gets focus
        changeFormLabel(el, false, true)
    }
    // save the original label texts in an array for later use
    const id = el.id
    const text = el.previousElementSibling.textContent
    const arr = {id:id, text:text}
    labelsOriginalTexts.push(arr)
})

/**
 * DSGVO CHECKBOX HANDLING
 */

const dsgvo = document.querySelector("#dsgvo")
const dsgvoLabel_errSpan = dsgvo.nextElementSibling.querySelector('.dsgvo_errMsg')

dsgvo.onclick = () => {
    if (dsgvo.checked) {
        dsgvoLabel_errSpan.textContent = ''
    }
}
dsgvo.checkOnSubmit = () => {
    if (!dsgvo.checked) {
        dsgvoLabel_errSpan.textContent = errMsg_dsgvoCheck
        return false
    } else {
        dsgvoLabel_errSpan.textContent = ''
        return true
    }
}
/** 
 * Check the last filled field directly on blur event 
 * */
const checkField = (el, submit) => {
    
    // get the value of the form input
    const formValue = el.value
    
    // only check immediately if the field is filled with a value
    if (formValue !== '') {
        if (el.type == 'text') {

            // Regex pattern for name with diacritics and dot [a-zA-Z0-9Àž.]
            const regex = /^[a-zA-Z0-9À-ž .'-]+$/

            if (regex.test(formValue)) {
                
                // remove the :invalid pseudo-class
                el.setCustomValidity("")
                
                changeFormLabel(el, false, true)
                if (submit) return true
            } else {
                
                el.setCustomValidity("Invalid field.")
                changeFormLabel(el, false, false)
                if (submit) return false
            }
        }  else if (el.type == 'email') {
            // die standard email-überprüfung stimmt nicht, es fehlt die .tld
            if (!el.checkValidity()) {
                // email field is not valid
                //el.setCustomValidity("Invalid field.")
                changeFormLabel(el, false, false)
                if (submit) return false
            } else {
                // email field is valid
                //el.setCustomValidity("")
                changeFormLabel(el, false, true)
                if (submit) return true
            }
        }  else if (el.type == 'select-one') {
            // if it's a select field remove the :invalid pseudo-class
            el.setCustomValidity("")
        }
    } else {

        // hier könnte ich die required Untersuchung unterbringen, das else wird ausgeführt, wenn das Feld leer ist
        // nur wenn "submit == true" und required == true mach dies und das
        if (submit && el.classList.contains('required')) {
            
            // only set the custom invalid for field types other than e-mail (as it is checked automatically with type=email)
            if(el.type != 'email'){
                el.setCustomValidity("Invalid field.")
            }
            changeFormLabel(el, true, false)
            return false

        } else {
            
            el.setCustomValidity("")
            changeFormLabel(el, submit, true)
            return true
        
        }
    }
}

const changeFormLabel = (el, submit, validity) => {
    
    const type = el.type
    const formLabel = el.previousElementSibling
    const formId = el.id
    const formOriginalText = labelsOriginalTexts.filter(({id}) => id === formId).map(({text}) => text)

    if (validity) {

        formLabel.textContent = formOriginalText[0]
        formLabel.classList.remove('invalid')

    } else {
        
        if (!submit) {
            if (type == 'text') {
            
                formLabel.textContent = errMsg_specialChars
            
            } else if (type == 'email') {
                
                formLabel.textContent = errMsg_email
            }
        } else {
            
            if (type != 'checkbox') {
                // All form fields marked as required and that are empty, excluding the checkbox(es)
                formLabel.textContent = errMsg_emptyReq
                // Add the correct classes for display
                setRequiredError(el, true)

            } else if (type == 'checkbox') {
                // probably not needed as checkboxes will not make it into this function...
            }
        }
        
        formLabel.classList.add('invalid')
    
    }
}

// save a reference to the form
const theForm = document.querySelector("form");
// here we need to distinguish what form type
// Kontaktformular = 'contact', Anmeldeformular = 'register', E-Mail-Benachrichtigung = 'notify'
// Anmeldeformular für Online-Vortrag = 'register-online'
// if no data-type is specified on the <form> or it is empty formType defaults to 'contact'
const formType = theForm && theForm.dataset.type ? theForm.dataset.type : 'contact'
// for registration and notification e-mails we add additional event related info: 
// event name
const formInfo = theForm && theForm.dataset.info ? theForm.dataset.info : ''
// event date
const formDate = theForm && theForm.dataset.date ? theForm.dataset.date : ''
// (online relevant for online events) a link to attend the online meeting
const formLink = theForm && theForm.dataset.link ? theForm.dataset.link : ''
// reset the form on pageload
theForm.reset();
// Submit functioniality
theForm.addEventListener('submit', e => {
    // Store reference to form
    const form = e.target

    // get status message references
    const statusBusy = form.querySelector('.status-busy');
    const statusFailure = form.querySelector('.status-failure');

    // Check timeout in Milliseconds
    const submitTime = Date.now()
    const timeDiff = submitTime - loadTime

    // Check all fields on submit and only if everything is valid / filled use the fetch
    const validityChecks = []
    inputs.forEach((el) => {
        let response = checkField(el, true)
        validityChecks.push(response)
    })
    // check the validityChecks Array and return true if one element in it is false
    const checkArr = (elem) => elem === false
    const fieldCheck = validityChecks.some(checkArr)
    // Check the dsgvo field, return true if checked
    const dsgvoCheck = dsgvo.checkOnSubmit()

    // Post data using the Fetch API
    // 
    if (!fieldCheck && dsgvoCheck && timeDiff > noTimeToSend) {

        // werde hier lieber mein eigenes Objekt schreiben, FormData API hat noch nicht 100% Support
        const theFormData = new FormData(form)
        /*const theFormData = (form) => {

            const serialized = []

            for (let i = 0; i < form.elements.length; i++) {

                let el = form.elements[i];

                if (!el.name || el.disabled || el.type === 'file' || el.type === 'reset' || el.type === 'submit' || el.type === 'button') {
                    continue
                };

                serialized.push ({
                    name: el.name,
                    value: el.value
                })
            }
            return serialized
        }
        theFormData(form)*/

        // Change the trapdoor secret to sth. else
        const timeString = submitTime.toString()
        // Append the secret
        theFormData.append('user_secret', timeString)
        // Append formInfo and possibly formDate and formLink
        if (formType && formType != '' && formType != 'contact'){
            theFormData.append('info', formInfo)
            if (formType == 'register' || formType == 'register_online' || formType == 'fest' || formType == 'ma' || formType == 'ma-waitlist') {
                theFormData.append('date', formDate)
                if (formType == 'register_online') {
                    theFormData.append('link', formLink)
                }
            }
        }

        fetch( ofTheGods + '_' + formType + langFlag + '.php', {
            method: form.method,
            body: theFormData
        })
        // We turn the response into text as we expect HTML
        .then(res => res.text())

        // Let's turn it into an HTML document
        .then(text => new DOMParser().parseFromString(text, 'text/html'))
    
        // Now we have a document to work with let's replace the <form>
        .then(doc => {
    
            // Create result message container and copy HTML from doc
            const result = document.createElement('div')
            result.classList.add('animate-response')
            //result.innerHTML = '<h2>Test erfolgreich</h3><p>Test für die Animation</p>'
            result.innerHTML = doc.body.innerHTML

            let formHeight = form.scrollHeight
            let elemTransition = 'opacity 0.4s ease-out'
            //
            result.style.height = formHeight + 'px';
            //const test = form.parentNode
            form.style.transition = ''
            requestAnimationFrame(function() {
                form.style.maxHeight = formHeight + 'px'
                form.style.transition = elemTransition
            })
            requestAnimationFrame(function() {
                //test.style.maxHeight = 0
                form.style.opacity = 0
            })

          // Allow focussing this element with JavaScript
          result.tabIndex = -1
            
          const formIntroDiv = form.parentNode.parentNode.firstElementChild;
          
          // And replace the form with the response children
          setTimeout (function() {
            form.parentNode.replaceChild(result, form)
            formIntroDiv.classList.add('hide-form-intro') }, 
            400)
          
    
          // Move focus to the status message
          //result.focus();
    
        })
        .catch(err => {
          // Unlock form elements
          Array.from(form.elements).forEach(field => field.disabled = false)
    
          // Return focus to active element
          lastActive.focus()
    
          // Hide the busy state
          statusBusy.hidden = false
    
          // Show error message
          statusFailure.hidden = false
    
        });
    
      // Before we disable all the fields, remember the last active field
      const lastActive = document.activeElement
    
      // Show busy state and move focus to it
      statusBusy.hidden = false
      statusBusy.tabIndex = -1
      statusBusy.focus()
    
      // Disable all form elements to prevent further input
      Array.from(form.elements).forEach(field => field.disabled = true)
    
      // Make sure connection failure message is hidden
      statusFailure.hidden = true
    }
    // prevent the default form submit
    e.preventDefault()
})
// The Calendar Downloads on the Events pages
const calBtn = document.querySelector("#calendar-btn");
if (calBtn) {
    calBtn.addEventListener('click', e => {
        const con = e.target.parentNode;
        con.querySelector(".calendar-menu").classList.toggle('is-hidden')
        con.querySelector(".btn-ghost__arrow").classList.toggle('is-active')
    })
}
